import React from 'react'
import { GraphScaleWrapper } from './style'

const GraphScaleWrapperComponent = () => {
  return (
    <GraphScaleWrapper className='brandImageryRowAppendices brandImageryRow tRow footer footerPPT tab2'>
      {[' -3 ', ' -2 ', ' -1 ', '0', ' +1 ', ' +2 ', ' +3 '].map((item, index) => (
        <span key={`scale_${index}`} className={`txt${index + 1}`}>
          {item}
        </span>
      ))}
    </GraphScaleWrapper>
  )
}

export default GraphScaleWrapperComponent
